//@ts-nocheck
import createSagaMiddleware from "redux-saga";
import { applyMiddleware, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import rootSaga from "../sagas/rootSaga";
import { composeWithDevTools } from "redux-devtools-extension";
import createRootReducer from "../reducers/Reducers";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer, createMigrate } from "redux-persist";

const createBrowserHistory = require("history").createBrowserHistory;

export const history = createBrowserHistory();

const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const middlewares = [thunk, sagaMiddleware, routeMiddleware];

const configureStore = (preloadedState) => {
   const store = createStore(
      preloadedState,
      composeWithDevTools(
         applyMiddleware(
            routerMiddleware(history), // for dispatching history actions
            ...middlewares,
         ),
      ),
   );

   sagaMiddleware.run(rootSaga);
   return store;
};

// If you ever need to make major changes to the redux, make sure to use redux-persist migrations
// This will prevent user from using cached redux.
const migrations = {
   0: () => {
      localStorage.removeItem("isPublicUserLogged");
      localStorage.removeItem("publicID");
      return {};
   },
};

const persistConfig = {
   key: "root",
   version: 5,
   storage: storage,
   blacklist: ["translations", "selectedRows", "devForm"],
   migrate: createMigrate(migrations, { debug: false }),
};
const persistedReducer = persistReducer(persistConfig, createRootReducer(history));

const store = configureStore(persistedReducer);

let persistor = persistStore(store);

export { persistor, store };
